import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { REACT_APP_API_URL } from "../../config/api-config"; 

// IMPORT YOUR LOGO HERE
import logo from "../../assets/images/logo.JPG"; 

const CustomerSelfRegistration = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    gender: "Male"
  });
  const [imageBase64, setImageBase64] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCameraCapture = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageBase64(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!imageBase64) {
      toast.warn("Please take a quick selfie to activate your profile!");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${REACT_APP_API_URL}/students/public/register`, {
        student_id: formData.phone, 
        first_name: formData.firstName,
        last_name: formData.lastName,
        mobile_no: formData.phone,
        selectType: formData.gender, 
        images: [imageBase64]
      });
      
      setSuccess(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={{ textAlign: "center", padding: "50px 20px", fontFamily: "'Inter', sans-serif", backgroundColor: "#f8fafc", minHeight: "100vh" }}>
        <h1 style={{ color: "#05CD99", fontSize: "80px", margin: "0 0 20px" }}>✓</h1>
        <h2 style={{ color: "#2B3674", fontWeight: "800" }}>Registration Complete!</h2>
        <p style={{ color: "#A3AED0", fontWeight: "500" }}>Your profile is now active. You can close this window.</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "450px", margin: "0 auto", padding: "20px", fontFamily: "'Inter', sans-serif", backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <ToastContainer position="top-center" />
      
      <div style={{ backgroundColor: "white", padding: "30px", borderRadius: "20px", boxShadow: "0 10px 25px rgba(0,0,0,0.05)" }}>
        
        {/* LOGO SECTION ADDED HERE */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img 
            src={logo} 
            alt="Company Logo" 
            style={{ maxWidth: "180px", maxHeight: "80px", objectFit: "contain" }} 
          />
        </div>

        <h2 style={{ color: "#2B3674", margin: "0 0 10px", textAlign: "center", fontWeight: "800" }}>Welcome! 👋</h2>
        <p style={{ color: "#A3AED0", textAlign: "center", marginBottom: "30px", fontSize: "14px", fontWeight: "500", lineHeight: "1.5" }}>
          Please complete your profile to activate your seamless access.
        </p>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <input required name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleInputChange} style={inputStyle} />
          <input required name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleInputChange} style={inputStyle} />
          <input required name="phone" type="tel" placeholder="Phone Number" value={formData.phone} onChange={handleInputChange} style={inputStyle} />
          
          <select required name="gender" value={formData.gender} onChange={handleInputChange} style={inputStyle}>
            <option value="" disabled>Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>

          <div style={{ marginTop: "15px", textAlign: "center" }}>
            <label style={{ 
              display: "block", 
              backgroundColor: imageBase64 ? "#e6fbf4" : "#4318FF", 
              color: imageBase64 ? "#05CD99" : "white", 
              border: imageBase64 ? "2px solid #05CD99" : "none",
              padding: "16px", borderRadius: "12px", fontWeight: "700", cursor: "pointer",
              transition: "all 0.3s ease"
            }}>
              {imageBase64 ? "📸 Selfie Captured! (Tap to retake)" : "📸 Tap to Take Selfie"}
              <input type="file" accept="image/*" capture="user" onChange={handleCameraCapture} style={{ display: "none" }} />
            </label>
            
            {imageBase64 && (
              <img src={imageBase64} alt="Selfie preview" style={{ width: "120px", height: "120px", objectFit: "cover", borderRadius: "50%", marginTop: "20px", border: "4px solid #05CD99", boxShadow: "0 4px 10px rgba(5, 205, 153, 0.3)" }} />
            )}
          </div>

          <button type="submit" disabled={loading} style={{ 
            marginTop: "25px", 
            backgroundColor: loading ? "#A3AED0" : "#2B3674", 
            color: "white", padding: "16px", border: "none", borderRadius: "12px", 
            fontWeight: "700", fontSize: "16px", cursor: loading ? "not-allowed" : "pointer",
            transition: "all 0.3s ease"
          }}>
            {loading ? "Activating Profile..." : "Submit & Activate"}
          </button>
        </form>
      </div>
    </div>
  );
};

const inputStyle = {
  padding: "16px", borderRadius: "12px", border: "1px solid #E2E8F0", 
  fontSize: "15px", backgroundColor: "#F8FAFC", outline: "none", color: "#2B3674",
  fontWeight: "500"
};

export default CustomerSelfRegistration;
